export default __webpack_public_path__ + "static/media/149.d04594b8.png";